import { createRouter, createWebHistory } from "vue-router";

import Dashboard 		from "@/views/dashboard/Main.vue";
import Login 			from "@/views/login/Main.vue";
import Client 			from "@/views/client/Main.vue";

const routes = [
	{
		path: "/",
		name: "dashboard",
		component: Dashboard
	},
	{
		path: "/login",
		name: "login",
		component: Login
	},
	{
		path: "/client/:id",
		name: "client",
		component: Client,
		props: route => ({ id: route.params.id })
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes, scrollBehavior(to, from, savedPosition) {
		return savedPosition || { left: 0, top: 0 };
	}
});

export default router;